import React from 'react';
import { motion } from 'framer-motion';
interface FeatureSectionProps {
  headline: string;
  subheadline?: string;
  imageUrl: string;
  backgroundColor: string;
  textColor?: string;
}
export function FeatureSection({
  headline,
  subheadline,
  imageUrl,
  backgroundColor,
  textColor = 'text-black'
}: FeatureSectionProps) {
  return <section className="py-24 px-6 overflow-hidden flex flex-col items-center" style={{
    backgroundColor
  }} data-id="element-14">
      <div className="max-w-5xl mx-auto w-full flex flex-col items-center text-center" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-12 max-w-2xl" data-id="element-16">
          <h2 className={`text-4xl md:text-5xl font-black tracking-tight mb-2 ${textColor}`} data-id="element-17">
            {headline}
          </h2>
          {subheadline && <h3 className={`text-2xl md:text-3xl font-bold ${textColor} opacity-90`} data-id="element-18">
              {subheadline}
            </h3>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-19">
          <img src={imageUrl} alt={headline} className="max-w-[280px] md:max-w-sm rounded-[2.5rem] shadow-2xl border-4 border-gray-900" data-id="element-20" />
        </motion.div>
      </div>
    </section>;
}